
<template>
  <!--修改物业账号-->
  <x-addEdit
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'editPropretyAccount',
  data () {
    let decoratorOptions = {
      userName: {
        rules: [
          { required: true, message: '请输入账号名' },
          { min: 2, max: 30, message: '账号名为2-30位' }
        ]
      },
      mobile: {
        rules: [{ required: true, message: '请输入手机号' }]
      },
      trueName: {
        rules: [
          { required: true, message: '请输入姓名' },
          { min: 1, max: 10, message: '姓名为1-10位' }
        ]
      },
      roleId: {
        rules: [{ required: true, message: '请选择角色' }]
      },
      status: {
        initialValue: 1,
        rules: [{ required: true, message: '请选择状态' }]
      }
    };
    console.log('property mobile rules: ', decoratorOptions.mobile);

    return {
      formList: [
        {
          label: '公司名',
          inputType: 'text',
          props: ['propertyName']
        },
        {
          label: '账号名',
          inputType: 'input',
          options: [],
          placeholder: '请输入账号名',
          disabled: true,
          props: ['userName', decoratorOptions.userName]
        },
        {
          label: '手机号',
          inputType: 'input',
          options: [],
          placeholder: '请输入手机号',
          disabled: true,
          props: ['mobile', decoratorOptions.mobile]
        },
        {
          label: '姓名',
          inputType: 'input',
          options: [],
          placeholder: '请输入姓名',
          props: ['trueName', decoratorOptions.trueName]
        },
        {
          label: '选择角色',
          inputType: 'select',
          options: [],
          placeholder: '请选择角色',
          mode: 'multiple',
          props: ['roleId', decoratorOptions.roleId]
        },
        {
          label: '状态',
          inputType: 'radioGroup',
          options: this.$store.state.statusList,
          placeholder: '',
          props: ['status', decoratorOptions.status]
        }
      ],
      formKey: {
        propertyName: '',
        userName: '',
        mobile: '',
        trueName: '',
        roleId: '',
        status: ''
      },
      addParam: {
        url: '',
        reqHandle: this.reqHandle // this.reqHandle
      },
      editParam: {
        url: '/property/user/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/property/user/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    this.propertyManageSelect([{index: 4, scope: 'formList'}]);
  },
  methods: {
    detailResHandle (data, that) {
      that.textObj = {propertyName: data.propertyName};
      let formValues = {};
      for (let item in data) {
        if (this.formKey.hasOwnProperty(item)) {
          formValues[item] = data[item];
        }
      }
      return formValues;
    },
    reqHandle (param) {
      param.roleId = param.roleId.join(',');
      return param;
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
